import type { IconData } from '@stacksjs/iconify-core'

export const emptyClipboardFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24.5 4c-7.008 0-11.6.247-14.437.494c-3.023.262-5.314 2.543-5.57 5.575C4.247 12.99 4 17.832 4 25.5s.247 12.509.493 15.431c.256 3.032 2.547 5.313 5.57 5.576c2.838.246 7.43.493 14.437.493c7.008 0 11.6-.247 14.437-.493c3.023-.263 5.314-2.544 5.57-5.576c.246-2.922.493-7.764.493-15.431s-.247-12.509-.493-15.431c-.256-3.032-2.547-5.313-5.57-5.575C36.099 4.247 31.507 4 24.5 4\"/><path fill=\"#2859c5\" d=\"M29.777 1.06c1.741.04 3.057 1.574 2.861 3.305l-.335 2.972A3 3 0 0 1 29.322 10H18.678a3 3 0 0 1-2.98-2.663l-.336-2.972c-.196-1.73 1.12-3.265 2.861-3.304C19.93 1.023 21.847 1 24.001 1s4.07.022 5.776.06\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default emptyClipboardFlat
